import { Redirect } from 'expo-router'

export default function RewardsRedirect() {
  return <Redirect href="/main/(tabs)/rewards" />
}
